import request from "@/plugins/axios"

export default class RuleAPI {
  /*
 * 获取系统信息设置
 * */
  static getSysSettingInfo() {
    return request.get(`/Crm/Sys/SysSettingInfo`)
  }


  /*
  * 保存系统信息设置
  * */
  static saveSysSetting(data) {
    return request.post(`/Crm/Sys/SaveSysSetting`,data)
  }

















}
